export default [
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/forgotPassword/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'auth',
      pageTitle: 'breadcrumb.forgotPassword',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/views/forgotPassword/ResetPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'auth',
      pageTitle: 'breadcrumb.resetPassword',
      redirectIfLoggedIn: true,
    },
  },
]
